import ReduxStore from '@core/libs/store/reduxStore';

import { setBlockUnload } from '../../../libs/store/slices/MontanaGui.slice.js';

export default function regionSwitcherEvents() {
  document.querySelectorAll('#modalRegionSwitcherOverlay .markets a')?.forEach((regionLink) =>
    regionLink.addEventListener('click', () => {
      ReduxStore.dispatch(setBlockUnload(true));
    })
  );
}
